<template>
  <div v-loading="loading">
    <student-list
      :heading="$tc('models.student', 2)"
      :students="students"
      @onOpenPort="handleOpenPort"
      @onClosePort="handleClosePort"
      @onDeleteStudent="handleDeleteStudent"
    >
      <template v-slot:actions>
        <ui-link
          type="default"
          size="small"
          style="margin-right: 5px;"
          :loading="refreshLoading"
          :disabled="refreshLoading || closeAllLoading"
          @click="handleRefreshStudentStatus"
        >
          <i v-if="refreshLoading" class="el-icon-loading"></i>
          <template v-else>{{ $t('misc.refresh_status') }}</template>
        </ui-link>
        <ui-link
          type="danger"
          size="small"
          :loading="closeAllLoading"
          :disabled="refreshLoading || closeAllLoading"
          @click="handleClosePortAll(students)"
        >
          <i v-if="closeAllLoading" class="el-icon-loading"></i>
          <template v-else>{{ $t('misc.close_port_all') }}</template>
        </ui-link>
      </template>
    </student-list>

    <student-creator
      class="mt-8"
      @onSaveImport="handleSaveImport"
      :buildingId="buildingId"
    />
  </div>
</template>

<script>
import UiLink from '@/components/ui/UiLink';
import StudentList from '@/app/students/components/StudentList';
import StudentCreator from '@/app/students/components/StudentCreator';
import {
  getBuildingStudents,
  createStudents,
  openPort,
  closePort,
  deleteStudent,
  closePortAll,
  updateStudentStatus
} from '../api';

export default {
  props: {
    buildingId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      students: [],
      loading: false,
      refreshLoading: false,
      closeAllLoading: false
    };
  },

  components: {
    UiLink,
    StudentList,
    StudentCreator
  },

  methods: {
    async handleRefreshStudentStatus() {
      this.refreshLoading = true;
      try {
        await updateStudentStatus(this.students);
        await this.getStudents();
      } catch (error) {
        this.$message({ message: this.$t('errors.general'), type: 'error' });
      } finally {
        this.refreshLoading = false;
      }
    },
    async getStudents() {
      const buildingId = this.$props.buildingId;
      this.loading = true;
      try {
        const students = await getBuildingStudents(buildingId);
        this.students = students;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$message({ message: this.$t('error.general'), type: 'error' });
      }
    },

    async handleSaveImport(importList) {
      this.loading = true;
      try {
        const payload = {
          buildingId: this.$props.buildingId,
          students: importList
        };
        await createStudents(payload);
        await this.getStudents();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$message({ message: this.$t('errors.general'), type: 'error' });
      }
    },

    async handleOpenPort(student) {
      this.loading = true;
      try {
        await openPort(student);
        student.portStatus = true;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$message({ message: this.$t('errors.general'), type: 'error' });
      }
    },

    async handleClosePort(student) {
      this.loading = true;
      try {
        await closePort(student);
        student.portStatus = false;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$message({ message: this.$t('errors.general'), type: 'error' });
      }
    },

    async handleClosePortAll(listStudents) {
      this.closeAllLoading = true;
      try {
        await closePortAll(listStudents);
        listStudents.forEach(student => {
          student.portStatus = false;
        });
      } catch (error) {
        this.$message({ message: this.$t('errors.general'), type: 'error' });
      } finally {
        this.closeAllLoading = false;
      }
    },

    async handleDeleteStudent(student) {
      this.loading = true;
      const studentId = student.id;
      try {
        const deletedId = await deleteStudent(studentId);
        this.students = this.students.filter(s => s.id !== deletedId);
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$message({ message: this.$t('errors.general'), type: 'error' });
      }
    }
  },

  async created() {
    await this.getStudents();
  }
};
</script>

<style></style>
